import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import LocationPageIndexList from "./LocationPageIndexList";
import LocationPageIndexMap from "./LocationPageIndexMap";
import LocationIcon from "!!raw-loader!../../assets/icons/location.svg";
import ListIcon from "!!raw-loader!../../assets/icons/list.svg";
import Link from "next/link";

export default function LocationPageIndex({ locations, header, labels }) {
  const router = useRouter();
  const { query, pathname } = router;
  const [view, setView] = useState("list");

  useEffect(() => {
    if (query.view === "list" || query.view === "map") setView(query.view);
    else {
      setView("list");
    }
  }, [query.view]);

  return (
    <div>
      <div className="absolute right-0 top-0 flex flex-row map-overlay mr-4 mt-4">
        <Link href={{ pathname, query: { ...query, view: "list" } }} shallow>
          <div
            dangerouslySetInnerHTML={{ __html: ListIcon }}
            className={`list-icon w-6 flex flex-col justify-center mr-3 ${
              view === "list" ? "icon-selected" : ""
            }`}
          />
        </Link>
        <Link href={{ pathname, query: { ...query, view: "map" } }} shallow>
          <div
            dangerouslySetInnerHTML={{ __html: LocationIcon }}
            className={`location-icon w-4 flex flex-col justify-center ${
              view === "map" ? "icon-selected" : ""
            }`}
          />
        </Link>
      </div>
      {view === "list" ? (
        <LocationPageIndexList locations={locations} header={header} labels={labels} />
      ) : (
        <LocationPageIndexMap locations={locations} labels={labels} />
      )}
    </div>
  );
}
